import { Empty, PageHeader, Popconfirm, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, EditOutlined, PlusCircleFilled, StopOutlined } from "@ant-design/icons";
import AgregarCaja from "./AgregarCaja/AgregarCaja";
import EditarCaja from "./EditarCaja/EditarCaja";
import AbrirCaja from "./AbrirCaja/AbrirCaja";


moment.locale("es");

class Cajas extends Component {
  state = {
    modalAgregar: false,
    modalEditar: false,
    modalAgregarAbrir: false,
    todasCajas: [],
    loading: false,
    cajaId: null,
  };

  // Abrir modal para agregar
  abrirAgregarCaja() {
    this.setState({ modalAgregar: true });
  };

  // Cerrar modal de agregar
  cerrarAgregarCaja() {
    this.setState({ modalAgregar: false });
    this.consultarTodasCajas();
  };

  // Abrir modal para editar
  abrirEditarCaja(cajaId) {
    this.setState({ modalEditar: true, cajaId: cajaId });
  };

  // Cerrar modal de editar
  cerrarEditarCaja() {
    this.setState({ modalEditar: false });
    this.consultarTodasCajas();
  };

  abrirAbrirCaja(cajaId) {
    //Primero checar si hay una sesion abierta, si asi es abiri la sesion
    this.setState({ loading: true });
    axios
      .post(
        "cajas/datosCajaAbrir",
        { cajaId: cajaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          if (res.data.cajaAbierta) {
            const relativeUrl = `/puntoDeVenta/${res.data.sesionId}`;
            const fullUrl = window.location.origin + relativeUrl;
            window.open(fullUrl, '_blank');
          } else {
            this.setState({ modalAgregarAbrir: true, cajaId: cajaId, modalAgregarAbrirSI: res.data.saldoInicial });
          }

        } else if (res.data.success === 1) {
          message.warning("No hay saldo anterior");
        } else {
          message.error("Error al consultar saldo");
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.error("Error al consultar saldo:", error);
        message.error("Error al consultar saldo");
        this.setState({ loading: false });
      });
  }

  cerrarAbrirCaja() {
    this.setState({ modalAgregarAbrir: false, cajaId: null });
  }


  componentDidMount() {
    this.consultarTodasCajas();
  }

  consultarTodasCajas() {
    this.setState({ loading: true });
    axios
      .post(
        "cajas/selectTodasCajas",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todasCajas: res.data.cajas
          });
        } else {
          message.error("Error no se encotraron Cajas");
        }
      });
  }

  // Deshabilita una cirugia
  deshabilitarCajas(id) {
    axios
      .post(
        "cajas/deshabilitarCaja",
        { cajaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Caja deshabilitada exitosamente");
          this.consultarTodasCajas();
        } else if (res.data.success === 1) {
          message.error("Error al deshabilitar la caja");
        } else {
          message.error("Error");
        }
      });
  }

  // Habilita una Cirugia
  habilitarCajas(id) {
    axios
      .post(
        "cajas/habilitarCaja",
        { cajaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Caja habilitada exitosamente");
          this.consultarTodasCajas();
        } else if (res.data.success === 1) {
          message.error("Error al habilitar la caja");
        } else {
          message.error("Error");
        }
      });
  }




  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
      },
      {
        title: "Caja",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
    {
      title: "Acción",
      key: "accion",
      align: "center",
      width: "25%",
      onHeaderCell: () => ({
        style: { textAlign: 'center', padding: '4px' }
      }),
      onCell: () => ({
        className: "acciones-sin-hover",
        style: { textAlign: 'center', padding: '4px' }
      }),
      render: (record, index) => {
        let buttons = [];

        buttons.push(
          <Tooltip 
            title="Editar Caja" 
            placement="top"
          >
            <ButtonItem
              key={`editar-${record._id}`}
              type="default"
              size="small"
              cyan
              icon={<EditOutlined />}
              onClick={() => this.abrirEditarCaja(record._id)}
            >
            </ButtonItem>
          </Tooltip>
        );

        if (record.estado === 1) {
          buttons.push(
            <Popconfirm
              key={`deshabilitar-${record._id}`}
              title="¿Seguro que quieres deshabilitar esta caja?"
              onConfirm={() => this.deshabilitarCajas(record._id)}
              okText="Sí"
              cancelText="No"
            >
              <Tooltip title="Deshabilitar" placement="top">
                <ButtonItem
                  type="default"
                  size="small"
                  lima
                  icon={<CheckCircleOutlined />}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );

          buttons.push(
            <Tooltip 
              title="Abrir Caja" 
              placement="top"
            >
              <ButtonItem
                key={`abrir-${record._id}`}
                type="default"
                size="small"
                naranja
                icon={<PlusCircleFilled />}
                onClick={() => this.abrirAbrirCaja(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );
        } else {
          buttons.push(
            <Popconfirm
              key={`habilitar-${record._id}`}
              title="¿Seguro que quieres habilitar esta caja?"
              onConfirm={() => this.habilitarCajas(record._id)}
              okText="Sí"
              cancelText="No"
            >
              <Tooltip title="Habilitar" placement="top">
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<StopOutlined />}
                >
                </ButtonItem>
              </Tooltip>
            </Popconfirm>
          );
        }

        return <div className="acciones-container">{buttons}</div>;
      },
    }
   ];

    return (
      <>
        <PageHeader
          title="Cajas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarCaja"
              olivo
              onClick={this.abrirAgregarCaja.bind(this)}
              className="botonAgregar"
            >
              Agregar Caja
            </ButtonItem>
          }
        />
        <TableItem
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <>
                    <p>
                      No hay registros de Cajas. Aquí puedes gestionar y
                      llevar un control de las Cajas.
                    </p>
                  </>
                }
              />
            ),
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasCajas}
          columns={columns}
          pagination={false}
        />
        <AgregarCaja
          visible={this.state.modalAgregar}
          cerrarAgregarCaja={this.cerrarAgregarCaja.bind(this)}
        />
        <EditarCaja
          visible={this.state.modalEditar}
          cerrarEditarCaja={this.cerrarEditarCaja.bind(this)}
          cajaId={this.state.cajaId}
          />
        <AbrirCaja
          visible={this.state.modalAgregarAbrir}
          cerrarAbrirCaja={this.cerrarAbrirCaja.bind(this)}
          cajaId={this.state.cajaId}
          saldoInicial={this.state.modalAgregarAbrirSI}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Cajas);
